/*
* @Author: LiuMouLiang
* @class:  通用字典
*/
import APIS from "_libs/API";
import {
    _for,
    uploadFile,
    reFileName,
    _trim,
    getFileExtName,
} from 'tools';
import { BASE_API, IS_MOCK, IS_KJMOCK } from '_libs/host'
export {
    getQueryQroduct,
    canApplyConservation,
} from '@/api/api'
const { API } = APIS;

export const getKjApiUrl = function(url){
    if(IS_MOCK) return url;
    return IS_KJMOCK ? `https://wyins.net.cn:8797/mock/${url}` : `${BASE_API}/${url}`;
}
//查询支持PC端保全的产品列表
export const getSupportPcConservationProductList = function () {
    return API.$get('/api/conservation/pc/getSupportPcConservationProductList');
};


//获取oss授权信息
export const getOssAuthInfo = function(dir = 'group') {
    return API.$fetch('get', {
        url: 'oss/getAuthInfo',
        params: { fileDir: dir },
    });
};

//oss上传
export const getOssUpload = function(file) {
    return new Promise((resolve, reject) => {
        return getOssAuthInfo()
            .then((data) => {
                if (!data.dir) reject(data);
                const url = window.location.port !== '' ? window.location.origin + '/oss/upload' : `https:${data.host}`; //跨域
                const fileList = { file: [file] };
                let extName = file.name ? getFileExtName(file.name) : 'jpg';
                extName = '.' + extName;
                const fileName = data.fileName ? data.fileName + extName : file.name ? reFileName(_trim(file.name, true)) : _keyid()+ extName;
                const params = {
                    OSSAccessKeyId: data.accessid,
                    key: data.dir + fileName,
                    signature: data.signature,
                    policy: data.policy,
                    success_action_status: '200',
                };
                return uploadFile(url, fileList, params)
                    .then((res) => {
                        if(res.status === 200){
                            const fileUrl = `https:${data.cdnMediaHost}${data.dir}${fileName}`;
                            resolve(fileUrl);
                        }else{
                            warning('getOssUpload',res);
                            reject(res);
                        };
                    })
                    .catch(reject);
            })
            .catch(reject);
    });
};

//开户行
export const getBankCodeList = function(productId) {
    return API.$fetch('get', {
        url: 'getBankCodeList',
        params: { productId },
    });
};

//开户地(第三方)
export const getBankAreaList = function(productId) {
    return API.$fetch('get', {
        url: 'getBankAreaList',
        params: { productId },
    })
};

export const getAreaCode = function() {
    return API.$fetch('get', {
        url: 'getAreaCode',
        params: { },
    })
};

//开户网点
export const getBankNetworkList = function(params) {
    return API.$fetch('get', {
        url: 'getBankNetworkList',
        params,
    });
};


// WEBPACK FOOTER //
// ./src/libs/unit.js